
import React, { useState, useEffect } from "react";
import MainLayout from '../layouts/MainLayout';
import { Popover } from 'antd';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import { fetchSuppliers, inActiveSupplier } from "../services/supplierServices";
import ViewSupplier from "../components/suppliers/view";
import EditSupplier from "../components/suppliers/edit";

function Suppliers() {

    const [sessionUserData, setSessionUserData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [suppliersData, setSuppliersData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [editData, setEditData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        getSuppliers();
    }, []);

     const getSuppliers = async () => {
        setDataLoading(true);
        try {
            const data = await fetchSuppliers(sessionUserData?.OrgId);
            setSuppliersData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            console.error('Failed to load sections:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const filteredData = Array.isArray(suppliersData)
    ? suppliersData.filter((item) => {
        const userName = item?.SupplierName?.toLowerCase() || '';
        const email = item?.Email?.toLowerCase() || '';
        const query = searchQuery.toLowerCase();

        return userName.includes(query) || email.includes(query);
    })
    : [];

    const handleView = (item) => {
        setViewData(item);
    };

    const handleEdit = (item) => {
        setEditData(item);
    };

    const recordsPerPage = 5;
    const totalPages = filteredData?.length ? Math.ceil(filteredData?.length / recordsPerPage) : 0;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    const handleDelete = async (item) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete supplier "${item.SupplierName}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {

                const response = await inActiveSupplier({
                    SupplierId: item.Id,
                    UpdatedBy: sessionUserData?.Id,
                });

                if (response.data.ResultData.Status === 'Success') {
                    Swal.fire('Deleted!', 'The supplier has been deleted.', 'success');
                    getSuppliers();
                } else {
                    Swal.fire('Delete!', 'Failed to delete supplier, try after sometime..!.', 'error');
                }

            } catch (error) {
                console.error('Error deleting supplier:', error);
                Swal.fire('Error', 'Something went wrong!', 'error');
            } finally {
                console.log();
            }
        }
    };

    return (
        <MainLayout>
            <div className='content'>
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Suppliers</h4>
                            <h6>Manage your suppliers</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                        
                    </ul>
                    <div  
                        className={`page-btn ${
                            sessionUserData.RoleId === 3 || sessionUserData.RoleId === 1 ? "d-block" : "d-none"
                        }`}
                    >
                        <a href="#" className="btn btn-primary"  
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightAdd"
                            aria-controls="offcanvasRightAdd"
                        >
                            <i className="ti ti-circle-plus me-1"></i>New Supplier
                        </a>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set">
                            <div className="search-input">
                                <span className="btn-searchset"><i className="ti ti-search fs-14 feather-search"></i></span>
                                <input type="search" className="form-cotrol" placeholder="Search"/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="no-sort">#</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th className="text-center">Address</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                {dataLoading ? (
                                    <tr>
                                        <td colSpan="12" className="text-center">
                                            <div className="container"></div>
                                        </td>
                                    </tr>
                                ) : currentRecords && currentRecords.length > 0 ? (
                                    currentRecords.map((item, index) => (
                                        <tr>
                                        <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                            <td>
                                                <a className="text-gray-800 text-hover-primary mb-1">{item.SupplierName}</a>
                                            </td>
                                            <td>
                                                <a href="#" className="text-gray-600 text-hover-primary mb-1">{item.Email}</a>
                                            </td>
                                            <td>{item.Phone || 'N/A'}</td>
                                            <td className="text-center">
                                                <i 
                                                    className="fa-solid fa-location-dot fa-lg"
                                                    title={item.Address || 'No address available'}
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'transform 0.2s',
                                                    }}
                                                    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                ></i>
                                            </td>
                                            <td className="">
                                                <Popover 
                                                    placement="bottom" 
                                                    content={
                                                        <div style={{ width: '8rem' }}>
                                                            <p  
                                                                className="text-hover-warning"
                                                                data-bs-toggle="offcanvas" 
                                                                data-bs-target="#offcanvasRightView" 
                                                                aria-controls="offcanvasRightView"    
                                                                onClick={() => handleView(item)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transition: 'transform 0.2s',
                                                                }}
                                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <i className="fa-regular fa-eye me-2 text-primary"></i>
                                                                View
                                                            </p>
                                                            <p  
                                                                className="text-hover-warning"
                                                                data-bs-toggle="offcanvas" 
                                                                data-bs-target="#offcanvasRightEdit" 
                                                                aria-controls="offcanvasRightEdit"    
                                                                onClick={() => handleEdit(item)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transition: 'transform 0.2s',
                                                                    marginTop: '-10px'
                                                                }}
                                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                                                                Edit
                                                            </p>
                                                            <p  
                                                                className="text-hover-warning"
                                                                onClick={() => handleDelete(item)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transition: 'transform 0.2s',
                                                                    marginTop: '-10px'
                                                                }}
                                                                onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                                                                onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <i className="fa-regular fa-trash-can text-danger me-2"></i>
                                                                Delete
                                                            </p>
                                                        </div>
                                                    }
                                                    trigger="hover"
                                                >
                                                    <button 
                                                        className="btn"
                                                    >
                                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                                    </button>
                                                </Popover>
                                            </td>
                                        </tr>
                                    ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <p>No Data Available</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="dt-paging paging_simple_numbers">
                                <nav aria-label="pagination">
                                    <ul className="pagination">
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link previous"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === 1}
                                                aria-label="Previous"
                                                onClick={handlePrevious}
                                            >
                                                <i className="previous"></i>
                                            </button>
                                        </li>

                                        {/* Page Numbers */}
                                        {getPaginationNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-current={page === currentPage ? "page" : undefined}
                                                    onClick={() => handlePageClick(page)}
                                                    disabled={page === "..."}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link next"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === totalPages}
                                                aria-label="Next"
                                                onClick={handleNext}
                                            >
                                                <i className="next"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditSupplier editObj={editData} />
            <ViewSupplier viewObj={viewData} />
        </MainLayout>
    )
}

export default Suppliers